import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import { transitionScene } from '../SceneTransition';
import QuestionScreen from './QuestionScreen';
import gameData from '../gameData';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  constructor() {
    super({ key: IntroScreen.KEY });
  }

  create() {
    const width = this.scale.width;
    const height = this.scale.height;

    this.backgroundImage = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._BckgWithoutTree, this).setOrigin(0);

    this.title = ABCyaPhaser.Images.addImage(width / 2, 130 - 600, UIAssetKeys._LogoDays, this);

    this.titleEffect(this.title);

    ABCyaPhaser.Tweens.addTween(this.title, 1400, { y: this.title.y + 600 }, Phaser.Math.Easing.Bounce.Out);

    this.button = ABCyaPhaser.Images.addImage(width / 2, 340, UIAssetKeys._ContinueBtnDays, this).setInteractive()
      .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.startButtonClicked, this);

    this.man = ABCyaPhaser.Images.addImage(width / 2 - 1000, height / 2 + 230, UIAssetKeys._title_man, this).setScale(0.65);

    const xAdjust = 830;

    const tree = ABCyaPhaser.Images.addImage(100, height / 2 + 5, UIAssetKeys._ForegroundTree, this);
    ABCyaPhaser.Tweens.addTween(this.man, 400, { delay: 400, x: this.man.x + xAdjust }, Phaser.Math.Easing.Linear);

    this.manEffect(this.man);

    this.jingle = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._Title_Screen_Jingle, this.jingle, gameData.muteJingle ? 0 : 1, true);

    this.titleSound = ABCyaPhaser.Audio.createSound(this);
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._1_Days_of_the_Week, this.titleSound);
  }

  titleEffect (sprite) {
    ABCyaPhaser.Tweens.addTween(sprite, 300, { scaleX: 0.99 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(sprite, 600, { scaleX: 1, delay: 300 }, Phaser.Math.Easing.Linear, () => this.titleEffect(sprite));
  }

  startButtonClicked () {
    this.titleSound.stop();
    this.titleSound.destroy();

    this.jingle.stop();
    this.jingle.destroy();
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Iris_Transition, this);

    transitionScene(this, QuestionScreen.KEY, 'radial');
  }

  manEffect (sprite) {
    ABCyaPhaser.Tweens.addTween(sprite, 600, { angle: 1, yoyo: true }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(sprite, 600, { angle: -1, delay: 1200, yoyo: true }, Phaser.Math.Easing.Linear, () => this.manEffect(sprite));

    ABCyaPhaser.Tweens.addTween(sprite, 600, { y: sprite.y + 10, yoyo: true, repeat: 1 }, Phaser.Math.Easing.Linear);
  }
}